// 多言語翻訳 (旧 utils/i18n.js を Vue.reactive 化、ロジックは旧版踏襲)
// translator.php API: https://medeputize.sakura.ne.jp/api/translator.php
;(function () {
  const TRANSLATOR_URL = 'https://medeputize.sakura.ne.jp/api/translator.php';

  const state = Vue.reactive({
    language: null, // null = 日本語 (元言語)
    translatedTexts: {}, // { [lang]: { [text]: result } }
    requested: [] // 既リクエスト済み
  });

  // language が変わったらバッファをクリア
  // 注意: Vue.reactive オブジェクトを丸ごと新規オブジェクトに置換 (state.x = {}) すると、
  // 既存の computed/template の reactivity 依存追跡が新オブジェクトで継続しない可能性がある。
  // 代わりに既存オブジェクトの中身を delete / length=0 でクリアし、 参照を維持する。
  Vue.watch(() => state.language, () => {
    Object.keys(state.translatedTexts).forEach((k) => { delete state.translatedTexts[k]; });
    state.requested.length = 0;
  });

  /**
   * 同期的翻訳 (非同期リクエストはバックグラウンド)
   * @param {string} text - 原文 (日本語)
   * @param {string} [option] - 'formattedInput' を渡すと FormattedInput 用正規化を適用
   */
  function i18n(text, option) {
    if (!text) return '';
    if (!state.language) return text;
    if (!state.translatedTexts[state.language]) state.translatedTexts[state.language] = {};

    if (!state.requested.includes(text)) {
      state.requested.push(text);

      const params = new URLSearchParams();
      params.append('text', text);
      params.append('target', state.language);

      axios
        .post(TRANSLATOR_URL, params)
        .then((response) => {
          let data = response.data;
          if (option === 'formattedInput') {
            data = data
              .replace(/（/g, '(')
              .replace(/）/g, ')')
              .replace(/\s*\|\s*/g, '|')
              .replace(/%\s*d/g, ' %d ')
              .replace(/%\s*l\s*\(\s*/g, ' %l(')
              .replace(/\s+\)/g, ')')
              .replace(/\s+/g, ' ');
          }
          state.translatedTexts[state.language][text] = data;
        })
        .catch((error) => {
          console.error('Translation error:', error);
        });
    }

    return state.translatedTexts[state.language][text] || text;
  }

  /**
   * 非同期翻訳 (await 可)
   */
  async function i18nAs(text) {
    if (!text) return '';
    if (!state.language) return text;
    if (!state.translatedTexts[state.language]) state.translatedTexts[state.language] = {};

    if (!state.requested.includes(text)) {
      state.requested.push(text);
      const params = new URLSearchParams();
      params.append('text', text);
      params.append('target', state.language);
      try {
        const response = await axios.post(TRANSLATOR_URL, params);
        state.translatedTexts[state.language][text] = response.data;
      } catch (error) {
        console.error('Translation error:', error);
        return text;
      }
    }
    return state.translatedTexts[state.language][text] || text;
  }

  /**
   * 日本語へ逆翻訳 (送信前に値を日本語に戻す)
   */
  async function toJapanese(text) {
    if (!text) return '';
    if (!state.language) return text;
    const params = new URLSearchParams();
    params.append('text', text);
    params.append('source', state.language);
    try {
      const response = await axios.post(TRANSLATOR_URL, params);
      return text + ' [日本語訳] ' + response.data;
    } catch (error) {
      console.error('Translation error:', error);
      return text;
    }
  }

  function setLanguage(lang) {
    state.language = lang;
    // SR / フォント render hint のため <html lang> も同期 (null は日本語扱い)
    if (document && document.documentElement) {
      document.documentElement.lang = lang || 'ja';
    }
  }

  window.i18nStore = {
    state,
    i18n,
    i18nAs,
    toJapanese,
    setLanguage,
    get language() { return state.language; }
  };
})();
